import { nodeApiClient } from './apiClient';

nodeApiClient.interceptors.request.use(
  (config) => {
    const username = localStorage.getItem("pmndp_username");

    config.headers = config.headers || {};

    if (username) {
      config.headers.username = username;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const pmndpAPI = {
  searchBeneficiary: async (data) => (await nodeApiClient.post('/pmndp/pmndp-search-beneficiery', data)).data,
  getDialysisHistory: async (data) => (await nodeApiClient.post('/pmndp/dialysis-history', data)).data,
  registerPatient: async (data) => (await nodeApiClient.post('/pmndp/patient-registration', data)).data,
  getStates: async () => (await nodeApiClient.post('/pmndp/states', {})).data,
  getDistricts: async (data) => (await nodeApiClient.post('/pmndp/districts', data)).data,
  getDialysisTypes: async () => (await nodeApiClient.post('/pmndp/dialysis-types', {})).data,
  getBplOptions: async () => (await nodeApiClient.post('/pmndp/bpl-options', {})).data,
  getProcedureTypes: async () => (await nodeApiClient.post('/pmndp/procedure-types', {})).data,
  getSlotList: async (data) => (await nodeApiClient.post('/pmndp/slot-list', data)).data,
  getMachineList: async () => (await nodeApiClient.post('/pmndp/machine-list', {})).data,
  getMachineMaster: async (data) => (await nodeApiClient.post('/pmndp/machine-master', data)).data,
  createSlot: async (data) => (await nodeApiClient.post('/pmndp/create-slot', data)).data,
  createMachine: async (data) => (await nodeApiClient.post('/pmndp/create-machine', data)).data,
  getDialysisList: async (data) => (await nodeApiClient.post('/pmndp/dialysis-list', data)).data,
  getPeritonealDialysisList: async (data) => (await nodeApiClient.post('/pmndp/peritoneal-dialysis-list', data)).data,
  getSlotsByDate: async (data) => (await nodeApiClient.post('/pmndp/slots-by-date', data)).data,
  scheduleDialysis: async (data) => (await nodeApiClient.post('/pmndp/schedule-dialysis', data)).data,
  unbookSlot: async (data) => (await nodeApiClient.post('/pmndp/unbook-slot', data)).data,
  sendDialysisOtp: async (data) => (await nodeApiClient.post('/pmndp/send-dialysis-otp', data)).data,
  verifyPatientOtp: async (data) => (await nodeApiClient.post('/pmndp/verify-patient-otp', data)).data,
  sendCompleteDialysisOtp: async (data) => (await nodeApiClient.post('/pmndp/send-complete-dialysis-otp', data)).data,
  verifyPatientOtpComplete: async (data) => (await nodeApiClient.post('/pmndp/verify-patient-otp-complete', data)).data,
  getDashboardCount: async (data) => (await nodeApiClient.post('/pmndp/dashboard-count', data)).data,
  getBagHistory: async (id) => (await nodeApiClient.get(`/pmndp/bag-history/${id}`)).data,
  saveBag: async (data) => (await nodeApiClient.post('/pmndp/save-bags', data)).data,
};